import gallery from "../components/gallerySplide";

gallery(3);

document.addEventListener('DOMContentLoaded', () => {
  if (window.location.href.includes('edital')) {
    document.querySelector('.post__content a').setAttribute('target', '_blank');
  }
})